
        ;
        'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _sfax = require('sfax');

var _sfax2 = _interopRequireDefault(_sfax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_sfax2['default'].baseUrl = '';

var domain = _config2['default'].domain;
exports['default'] = {
    submitFeedback: function submitFeedback(payload) {
        return (0, _sfax2['default'])({
            url: 'https://house.focus.cn/baseApi/feedback',
            type: 'post',
            data: payload
        });
    }
};;
    


// WEBPACK FOOTER //
// ./~/@front-end/common-module-vm/feedback-dialog/model/api/index.js